import {defineStore} from "pinia";
import { formatNumber } from 'devextreme/localization';
import { reactive, ref,computed} from 'vue';

//import {cities as dataCities,templateKarkas as dataTemplateKarkas,articleDependencies as dataArticleDependencies,
  //  articlePrices as dataArticlePrices,articleTree  as dataArticleTree,articles as dataArticles} from '../data/testdata'
import {getData} from '../api/bitrixMethods'
import { v4 as uuidv4 } from 'uuid';
export const useCalcBuildingStore = defineStore('storeCalcBuilding', () => {
    const fetchData = getData();
    const nameText = ref(null)
    const currentColor = ref(0);
    const phoneText = ref(null)
    function createReactiveArticle(){
        return reactive({
            _id: "" as string,
            articleCode: "" as string,
            title: "" as string,
            type: "" as string,
            imageTemplate: {} as any,
            isActual: true as boolean,
            measureId: "" as string,
            gost: "" as string,
            secondaryTitle: "" as string,
            headerTitle: "Товар не найден. Попробуйте другие параметры" as string,
            prices: {
                _id: "" as string,
                percent : 0 as number,
                price : 0 as number,
                priceWithDiscount: 0 as number,
                priceIsFounded:false
            } as any,
            formatedPrices: {
                price : 0 as number,
                priceWithDiscount: 0 as number,
                discount: 0 as number
            } as any,
            params:{} as any,
            dependencies:[] as any
    
        })
    }
    function createReactiveBasketItem(){
        return reactive({
            _id: "" as string,
            articleId: "" as string,
            count: 0 as number,
            isDisabled: false as boolean,
            isSelected: true as boolean,
            originPriceId: "" as string,
            shippingDate: "" as string,
            basketId: "" as string,
            secondaryTitle: "" as string,
            createdBy: "" as string,
            modifiedBy: "" as string,
            createdOn: "" as string,
            modifiedOn: "" as string,
            parentId: "" as string
        })
    }
    function createReactiveBasket(){
        return reactive({
            _id: "" as string,
            //isDisabled: false as boolean,
            guid: "" as any,
            number: 1 as Number,
            pageTemplateId: "" as string,
            userId: "" as string,
            userIdUnverified: "" as string,
            statusCode: "" as string,
            parentBasket: "" as string,
            modifiedOn: "" as string,
            modifiedBy: "" as string,
            createdOn: "" as string,
            createdBy: "" as string,
            deliveryInfo: {} as any
        })
    }
    const cities =  ref([]) as any
    const relations =  reactive([

    ]) as any
    const unicBasketArticles = ref({frame:{isSelected: false, params: {}}, roof:{isSelected: false, params: {}}, walls:{isSelected: false, params: {}}, complect:{isSelected: false, params: {}},}) as any 
    const dataIsInit =  ref(false)
    const telephone =  ref('8 800 300 65 59')
    const managerId = ref(false as any)
    const managerIdCheck = ref(true)
    const basketRef = ref("")
    const links = reactive({
        cartCardIFramePath: "" as string,
        cartCardPath: "" as string
    })
    const bpmIdCheck = ref(true)
    const mainIdBasket =  ref("")
    const basketStatus =  ref(false)
    const tagBoxRef = ref()
    //В обратном порядке - чем выше индекс, тем первее будет стоять элемент 
    const colors = ref([4006, 3020, 2004, 1018])
    const currentCardParams = reactive({
        height:0 as number,
        width: 0 as number,
        length: 0 as number,
        environmentId:"" as any
    })
    //sessionStorage.setItem('lk_session_jwt', result.jwt);
    //sessionStorage.setItem('modified_session_user',managerId);
    function createMiniBasketItem(){
        return reactive({
            article: undefined as any,
            guidItem: "" as string,
            title:"" as string,
            id:"" as string,
            basketItem: undefined as any
        })
    }
    const article = createReactiveArticle();
    const basket = createReactiveBasket()
    var user = ""
    var userId = ""
    const miniBasket = reactive([]) as any
    const ifr = ref(false)
    const idBasket = reactive([])as any 
    const articleIsFounded = ref(false)
    const newFrame = ref(false)
    const userData = ref({})
    const pageIsFounded = ref(true)
    function createConstants(){
        return (ref({length:[]as any,width:[] as any,height:[] as any}))
    }
    const constants = createConstants();
    

    const addItemInBasket = async (article: any, basketItemId = "") => {
        if (!basketStatus.value) {
          if (user === 'userId') {
            basket.userId = userId;
          } else {
            basket.userIdUnverified = userId;
          }
      
          basket.modifiedBy = managerId.value ? managerId.value : userId;
          basket.createdBy = managerId.value ? managerId.value : userId;
          basket.pageTemplateId = '67f165979b92985689641370';
          basket.statusCode = 'current';
          basket.guid = uuidv4();
      
          const param = { data: basket };
      
          const result = await fetchData.createBasket(param);
      
          if (result.isSuccess) {
            basketStatus.value = true;
            Object.assign(basket, result.data);
            await addItem(article, basketItemId); 

            
            return true;
          } else {

            return false;
          }
        } else {
          await addItem(article, basketItemId); 
          return true;
        }
      };

    const readItem = ((basketItem:any, article:any)=>{
        const miniBasketItem = createMiniBasketItem();
        if (article.type == 'frame')
            {
                mainIdBasket.value = basketItem._id
            }
        miniBasketItem.basketItem = Object.assign({},basketItem)
        miniBasketItem.article = Object.assign({},article)
        if (unicBasketArticles.value.hasOwnProperty(miniBasketItem.article.type)) {
            unicBasketArticles.value[miniBasketItem.article.type].isSelected = true
            unicBasketArticles.value[miniBasketItem.article.type].params = article.params
        }
        miniBasketItem.title = miniBasketItem.article.tagTitle;
        const guidItem = uuidv4()
        miniBasketItem.guidItem = guidItem;
        miniBasketItem.id = basketItem._id
        idBasket.push(guidItem);
        miniBasket.push(miniBasketItem)
        
        tagBoxRef.value?.instance?.option("dataSource", miniBasket)
        tagBoxRef.value?.instance?.option("value", idBasket)
    })
    const addLog = async (myName: any, myPhone: any) => {
        const param = {data:{formName:'Запросить комплектацию у менеджера', payload:JSON.stringify({name: myName, phone: myPhone})}}
        await fetchData.addFormLog(param);
    }
    //var currentColor = "";
    const addItem = async (article: any, basketItemId = "") => {
        const basketItem = createReactiveBasketItem();
        basketItem.articleId = article._id;
        basketItem.basketId = basket._id;
        basketItem.originPriceId = article.prices._id;
        basketItem.modifiedBy = basket.modifiedBy;
        basketItem.createdBy = basket.createdBy;
        basketItem.count = 1;
        basketItem.isSelected = true;
        if (article.type == 'complect') {
            currentColor.value = extractOKNumber(article.articleCode);
        }
        if (article.type !== 'frame') {
          const frame = miniBasket.find((item: any) => item.article.type === 'frame');
          basketItem.parentId = frame ? frame.id : "";
        } else {
          basketItem.parentId = "";
        }
      
        const param = { data: basketItem };
      
        const result = await fetchData.addBasketItem(param);
      
        if (result.isSuccess) {
          readItem(result.data, article);
          return true;
        } else {
          console.error('Ошибка при добавлении basket item');
          return false;
        }
      };
    const getDisabled = ((type:any)=>{
        if (type == 'frame' && miniBasket.length > 0) {
            
            return ref(true)
        }
        if (unicBasketArticles.value.hasOwnProperty(type)) {
            return ref(unicBasketArticles.value[type].isSelected)
          } else {
            return ref(false)
          }
    })

    const removeItemFromBasket =((guid: any, level = 0)=>{
        
        var artId = miniBasket.find((item: any)  => item.guidItem === guid).id
        var itemDelete = miniBasket.find((item: any)  => item.guidItem === guid)
        if (itemDelete.article.type == 'complect') {
            currentColor.value = 0;
        }
        if (itemDelete.article.type == 'frame' && level == 0) {
            miniBasket.forEach((element: { basketItem: { parentId: any; }; guidItem: any; }) => {
                    if (element.basketItem.parentId == artId) 
                   removeItemFromBasket(element.guidItem, ++level)
                
            });
        }
        const param = {data:{_id:artId}}
        fetchData.removeBasketItem(param).then((result)=>{
            if (result.isSuccess){
                const indexToRemoveTag = idBasket.findIndex((item: any) => item === guid);
            if (indexToRemoveTag !== -1) {
                idBasket.splice(indexToRemoveTag, 1);
                }
            const indexToRemoveMini = miniBasket.findIndex((item: any)  => item.guidItem === guid);
            try {
            if (unicBasketArticles.value.hasOwnProperty(miniBasket.find((item: any)  => item.guidItem === guid).article.type)) {
                unicBasketArticles.value[miniBasket.find((item: any)  => item.guidItem === guid).article.type].isSelected = false
            }
        } catch {}
            
            //{
                
            //}       
            if (indexToRemoveMini !== -1) {
                miniBasket.splice(indexToRemoveMini, 1);
            }
            tagBoxRef.value?.instance?.option("dataSource", miniBasket)
            tagBoxRef.value?.instance?.option("value", idBasket)
            
            }
            else {
                //Что делать??
            }
            return true
            })
            return true
    })

   
    function getCookie(name:any) {
        let cookie = document.cookie.split('; ').find(row => row.startsWith(name + '='));
        return cookie ? cookie.split('=')[1] : null;
      }
    function getUser() {
        const params = new URLSearchParams(window.location.search);
const bpmUserId = params.get("userId");
managerId.value = params.get("modifiedUserId") 
const ascentors = window?.location?.ancestorOrigins;
        if (ascentors?.length){
            if (ascentors[0] =='https://bpm.evrazsteelbox.ru' || ascentors[0] == 'https://preprod.evrazsteelbox.ru'){

            
                ifr.value = true
                if (bpmUserId && managerId) {
                    console.log('yes url')
                return fetchJWTById(bpmUserId).then((result)=>{
                    user = 'userId'
                    userId = bpmUserId
                    sessionStorage.setItem('lk_session_jwt', result.jwt);
                    sessionStorage.setItem('modified_session_user',managerId.value);
                })
            } else if (sessionStorage.getItem('modified_session_user') && sessionStorage.getItem('lk_session_jwt')) {
                console.log('no url')
                return fetchVerifiedUserById(sessionStorage.getItem('lk_session_jwt')).then((result)=>{
                    managerId.value = sessionStorage.getItem('modified_session_user')
                    user = 'userId'
                    userId = result._id
                })
            } else {
                if (!sessionStorage.getItem('modified_session_user')) {
                    managerIdCheck.value = false
                }
                if (!sessionStorage.getItem('userId')) {
                    bpmIdCheck.value = false
                }
                return false
            }
            }
          } else {
            console.log("Страница открыта напрямую (не в iframe)");
          }
        var verifiedUser = localStorage.getItem("lk_jwt")
        if (verifiedUser != null){
        return fetchVerifiedUserById(verifiedUser).then((result)=>{
            user = 'userId'
            userId = result._id
        })
    } else {
        var unverifiedUser = getCookie('BITRIX_SM_GUEST_ID')
        if (unverifiedUser != null){
            return fetchUnverifiedUserById(unverifiedUser).then((result)=>{
                user = 'userIdUnverified'
                userId = result._id
            })
        } else {
            //localhost
            user = 'userIdUnverified'
            userId = 'IgorUserId'
        }
    }
    }
    function extractOKNumber(articleCode: any) {
        const match = articleCode.match(/ОК(\d+)/);
        return match ? parseInt(match[1], 10) : Infinity; // Infinity — если нет ОК, чтобы ушло в конец
      }
    const removeSpans = (() => {
        var idToDelete = Array()
        idBasket.forEach((id: any) => {
            
            if (true) {
            idToDelete.push(id)  
            } 
        });
        idToDelete.forEach(id => {
            removeItemFromBasket(id)
        })
        tagBoxRef.value?.instance?.option("dataSource", miniBasket)
        tagBoxRef.value?.instance?.option("value", idBasket)
        return true
    })
    const setArticle = ((unformedArticle:any, level:number) => {
        
                articleIsFounded.value = true
                unformedArticle.prices = unformedArticle.prices[0]
                unformedArticle.prices.priceIsFounded = true
                
                unformedArticle.formatedPrices = {
                    priceWithDiscount : formatNumber(unformedArticle.prices.priceWithDiscount, {currency:"RUB",type:"currency"}),
                                    price : formatNumber(unformedArticle.prices.price, {currency:"RUB",type:"currency"}),
                                    discount: formatNumber((unformedArticle.prices.price - unformedArticle.prices.priceWithDiscount), {currency:"RUB",type:"currency"})
                }
                if (unformedArticle.dependencies.length > 0) {
                    unformedArticle.dependencies.forEach((x: any)=>{
                        const depArticle = x
                        const reactiveDepArticle = createReactiveArticle();
                        setArticle(depArticle, level+1)
                        Object.assign(reactiveDepArticle,depArticle) 
                        article.dependencies.push(reactiveDepArticle);
                    })
                }
                if (level == 0) {
                Object.assign(article,unformedArticle)
                newFrame.value = checkFrame()
                }
    })
    function checkFrame() {
        
        const selectedFrame = miniBasket.find((x: { article: { type: string; }; }) => x.article.type == 'frame')
        if (selectedFrame != undefined) {
            if (selectedFrame.article._id == article._id) {
                return false
            } else {
                return true
            }
        } else {
            return false
        }
        
    }
    const switchArticle= ((article:any, type:any) => {
        miniBasket.forEach((art: { article: { type: any; }; guidItem: any; }) => {
            if (art.article.type == type) {
                removeItemFromBasket(art.guidItem)
                unicBasketArticles.value[type].isSelected = true
            }            
        });
        if (article != "" && unicBasketArticles.value[type].isSelected == true && type == 'frame') {
        addItemInBasket(article)
        }
        if ((type == 'roof' || type == 'walls') && JSON.stringify(unicBasketArticles.value[type].params) != '{}') {

            if (article == "") {

                unicBasketArticles.value[type].isSelected = false
            } else {

                addItemInBasket(article)
            }
        }
        return true
    })
    const fetchVerifiedUserById = ((token:any) =>{
        const param = {data:{'jwt':token}}
        return fetchData.getVerifiedUser(param).then((result)=>{
            if (result.isSuccess){
                return result.data    
            }
            else{
            }
            return ""
        })
    })
    const fetchJWTById = ((id:any) =>{
        const param = {"userId":id, "token":"2s3wl0qnzr6r2ypm"}
        userData.value = param;
        return fetchData.getJWTByUserId(param).then((result)=>{
            if (result.isSuccess){
                return result.data    
            }
            else{
            }
            return ""
        })
    })
    const fetchUnverifiedUserById = ((cook:any) =>{
        const param = {data:{'bx_cookie':cook}}
        return fetchData.getUnverifiedUser(param).then((result)=>{
            if (result.isSuccess){
                return result.data   
            }
            else
            {
                return ""
            }
            
        })
    })
    const fetchArticleById = ((articleId:any) =>{
        const param = {data:{'fields[_id]':articleId}}
        let mainArticle2 

        return fetchData.getarticle(param).then((result)=>{
            if (result.isSuccess){
                setArticle(result.data[0], 0)      
            }
            else{
                mainArticle2 = []
            }
        
        })
        
    })

    const fetchArticleByIdfromServer = ((articleId:any) =>{
        const param = {data:{'fields[_id]':articleId}}
        let mainArticle2 

        return fetchData.getarticle(param).then((result)=>{
                return result
        
        })
        
    })
    async function fetchBasket(){
        await getUser()
        const param = user == 'userId' ? {data:{'statusCode':'current', 'userId':userId}} : {data:{'statusCode':'current', 'userIdUnverified':userId}}
        return fetchData.getbasket(param).then((result)=>{
            if (result.isSuccess){
                if (result.data.length > 0) {
                    result.data.forEach((element:any) => {
                        if (result.data.lastIndexOf(element) != (result.data.length-1)) {
                            let updateParam = {data:{'_id':element._id, 'fields[statusCode]':'abandoned'}}
                            fetchData.updateBasket(updateParam).then((result1)=>{
                            })
                        }
                    });
                    basketStatus.value = true
                    Object.assign(basket, result.data[result.data.length - 1])
                    if (result.data[0].basketItems != undefined) {
                    result.data[0].basketItems.forEach((element:any) => {
                        readItem(element, element.article)
                    });
                }
                    pageIsFounded.value = true
                    if (result.data[0].basketItems != undefined) {
                    const mainArticle = result.data[0].basketItems.find((x: { article: { type: string; }; }) => x.article.type == 'frame').article
                    setArticle(mainArticle, 0)
                    return true
                    }
                    else 
                    {
                        return false
                    }
                } else {
                    return false
                }
            } else {
                pageIsFounded.value = false
                return false
            }})
        
    }
    const fetchArticleByTemplateId = ((pageId:any)=>{
        const param = {data:{'fields[_id]':pageId}}
        return fetchData.gettemplate(param).then((result)=>{
            if (result.isSuccess){
                pageIsFounded.value = true
                const mainArticleId = result.data.articleId
                return fetchArticleById(mainArticleId)
            } else {
                pageIsFounded.value = false
                return Promise.resolve(false)
            }})
    })
    const fetchArticleTemplateByName = ((pageId:any)=>{
        const param = {data:{'pageName':pageId}}
        return fetchData.getTemplateByParam(param).then((result)=>{
      
            if (result.isSuccess){
                pageIsFounded.value = true
                const mainArticleId = result.data[0].articleId
                return fetchArticleById(mainArticleId)
            } else {
                pageIsFounded.value = false
                return false
            }})
    })
    const fetchInitData = async()=>{
        return await fetchData.getconstants().then((result)=>{
            if (result.isSuccess){
                constants.value = result.data
                fetchData.getcities().then((result)=>{
                    if (result.isSuccess){
                          cities.value = result.data
                          fetchData.getrelations().then((result)=>{
                            if (result.isSuccess){
                                relations.value = result.data
                                fetchData.getLinks().then((result)=>{
                                    if (result.isSuccess){
                                        Object.assign(links, result.data[0])
                                        
                                    }
                                    return dataIsInit.value = true; 
                                    
                                })
                            }
                            
                        })
                    }
                    else{
                        cities.value = []
                    }
        
                })
            }

        })
        

        
        
        
    }
    async function switchFrames(){
        let fr = false;
        let wa = false;
        let ro = false;
        var walls = article.dependencies.find((x: { type: string; params: any; }) => x.type == 'walls' && JSON.stringify(x.params) == JSON.stringify(unicBasketArticles.value['walls'].params))
                            var roof = article.dependencies.find((x: { type: string; params: any; }) => x.type == 'roof' && JSON.stringify(x.params) == JSON.stringify(unicBasketArticles.value['roof'].params))
                            for (const art of miniBasket) {
                                const ty = art.article.type;
                            
                                await removeItemFromBasket(art.guidItem); // важно!
                            
                                if (ty === 'frame') fr = true;
                                if (ty === 'walls') wa = true;
                                if (ty === 'roof') ro = true;
                              }
        if (fr) {
            await addItemInBasket(article)
        }
        if (walls != undefined && wa) {
            await addItemInBasket(walls)
        }
        if (roof != undefined && ro) {
            await addItemInBasket(roof)
        }
        
        /*switchArticle(article, 'frame')
        var walls = article.dependencies.find(x => x.type == 'walls' && JSON.stringify(x.params) == JSON.stringify(unicBasketArticles.value['walls'].params))
                            var roof = article.dependencies.find(x => x.type == 'roof' && JSON.stringify(x.params) == JSON.stringify(unicBasketArticles.value['roof'].params))
                            console.log(walls)
                            if (walls != undefined) {

                                switchArticle(walls, 'walls')
                            } else {
                                switchArticle("", 'walls')
                            }
                            if (roof != undefined) {

                                switchArticle(roof, 'roof')
                            } else {
                                switchArticle("", 'roof')
                            }*/
    }

    const changeCardParams = ((field: string, param: any)=>{
      

        const oldParam = currentCardParams[field as keyof typeof currentCardParams];
        if(param !=oldParam){
            currentCardParams[field as keyof typeof currentCardParams] = param    
      
            const relObj = relations?.value?.find((x: { mainParameter: { [x: string]: any; }; })=>x.mainParameter[field] ==  param);
            if (relObj){
                Object.keys(relObj.dependencies).forEach(key=>{
                    const dimvals = relObj.dependencies[key];
                    if (dimvals.length){
                        const relVal =  dimvals.find((x: any)=> x == currentCardParams[key as keyof typeof currentCardParams])
                        if(!relVal){
                            currentCardParams[key as keyof typeof currentCardParams] = dimvals[0];
                        }
                    }
                })
            }

            if (currentCardParams.environmentId && currentCardParams.height && currentCardParams.length && currentCardParams.width){
                const prmtr = {data:{'fields[width]':currentCardParams.width,'fields[height]':currentCardParams.height,'fields[length]':currentCardParams.length,'fields[environmentId]':currentCardParams.environmentId}}
                    return fetchData.getarticle(prmtr).then((result)=>{
                        if (result.isSuccess){
                            if (result.data.length > 0) {
                        
                            return setArticle(result.data[0], 0)
                            } else {
                                const emptyArticle = createReactiveArticle();
                            Object.assign(article,emptyArticle)  
                            articleIsFounded.value = false
                            }
                        } else {
                            const emptyArticle = createReactiveArticle();
                            Object.assign(article,emptyArticle)  
                            articleIsFounded.value = false
                        }})

            }
        }
        
    })

    const currentButtons = computed(()=>{
        let buttonsArray: any[] = []
        Object.keys(constants.value).forEach(key=>{
            const buttonsDimGroup = {dim:key, vals: constants.value[key as keyof typeof constants.value].map((x: { value: any; })=>x.value)}
            buttonsArray.push(buttonsDimGroup);
        })
        if(relations.value&& relations.value.length){
            relations.value.forEach((item: any)=>{
                Object.keys(item.mainParameter).forEach(mainParamKey=>{
                    const mainParamVal = item.mainParameter[mainParamKey]
                    if (currentCardParams[mainParamKey as keyof typeof currentCardParams] == mainParamVal){
                        Object.keys(item.dependencies).forEach(depKey=>{
                            buttonsArray = buttonsArray.filter(butItem => butItem.dim!=depKey)
                            const newButtonsDimGroup = {dim:depKey, vals: item.dependencies[depKey]}
                            buttonsArray.push(newButtonsDimGroup);
                        })
                    }
                })
            })
        }
        
     
        return buttonsArray;
    })
    return {
        cities,
        getUser,
        dataIsInit,
        switchFrames,
        fetchInitData,
        fetchBasket,
        fetchArticleByIdfromServer,
        fetchArticleByTemplateId,
        fetchArticleTemplateByName,
        addItemInBasket,
        removeItemFromBasket,
        article,
        constants,
        relations,
        bpmIdCheck,
        managerIdCheck,
        articleIsFounded,
        pageIsFounded,
        miniBasket,
        removeSpans,
        basketRef,
        checkFrame,
        newFrame,
        links,
        ifr,
        idBasket,
        tagBoxRef,
        currentColor,
        getDisabled,
        changeCardParams,
        unicBasketArticles,
        currentCardParams,
        currentButtons,
        nameText,
        phoneText,
        userData,
        telephone,
        colors,
        addLog
        
    }
});